import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import StagingBanner from "../components/StagingBanner";
import FreePlanBanner from "../components/ui/FreePlanBanner";
import CompanyInvitationBanner from "../components/ui/CompanyInvitationBanner";

const PageLoader = () => (
  <div className="flex items-center justify-center py-24">
    <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-brand-yellow" />
  </div>
);

const MainLayout = ({ children }) => (
  <div className="App min-h-screen flex flex-col">
    <Navbar />
    <StagingBanner />
    <FreePlanBanner />
    <CompanyInvitationBanner />
    <main className="flex-grow">
      <Suspense fallback={<PageLoader />}>
        {children ?? <Outlet />}
      </Suspense>
    </main>
    <Footer />
  </div>
);

export default MainLayout;
